/* Below Average — scroll-reveal
   Adds a quiet editorial "rise into place" to Shop-the-Looks rows and product
   cards as they enter the viewport. Fully optional: bails out under
   prefers-reduced-motion or when IntersectionObserver is unavailable, leaving
   all content visible. No layout shift — the hidden state is CSS-gated. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.featured-looks__row',
    '#MainContent .product-grid product-card',
    '#MainContent .product-recommendations product-card',
  ];

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ba-in');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function reveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var found = [];
    SELECTORS.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(function (el) {
        if (!el.classList.contains('ba-reveal') && !el.dataset.baSeen) found.push(el);
      });
    });
    if (!found.length) return;

    var viewportH = window.innerHeight || document.documentElement.clientHeight;

    // Stagger siblings that share a parent for a gentle cascade.
    var groups = new Map();
    found.forEach(function (el) {
      var parent = el.parentElement || document.body;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(el);
    });
    groups.forEach(function (group) {
      group.forEach(function (el, i) {
        el.dataset.baSeen = '1';
        // Never hide content already in the first viewport — doing so would
        // delay LCP and flash the (likely LCP) image. Only animate what is
        // genuinely below the fold; everything above paints immediately.
        if (el.getBoundingClientRect().top < viewportH) return;
        el.style.transitionDelay = (Math.min(i, 6) * 0.07).toFixed(2) + 's';
        el.classList.add('ba-reveal');
        observer.observe(el);
      });
    });
  }

  function init() {
    reveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when a section is re-rendered (theme editor / dynamic sections).
  document.addEventListener('shopify:section:load', function (event) {
    reveal(event.target);
  });
})();
